import type { AutoGenReview } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { AUTO_GEN_REVIEWS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRemoveAutoGenReviews(dispensaryId: string) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();
  const queryClient = useQueryClient();
  const { mutate: removeAutoGenReviews, isPending: isLoadingRemoveAutoGenReviews } = useMutation({
    mutationKey: [AUTO_GEN_REVIEWS_KEY],
    mutationFn: (scheduleId: string) => banksApi.deleteAutoGenReview(userBankId, dispensaryId, scheduleId),
    onSuccess: (_data, scheduleId) => {
      queryClient.setQueryData(
        [AUTO_GEN_REVIEWS_KEY, userBankId, dispensaryId],
        (reviews?: AutoGenReview[]) => reviews?.filter((review) => review.id !== scheduleId)
      );
      queryClient.invalidateQueries({ queryKey: [AUTO_GEN_REVIEWS_KEY, userBankId, dispensaryId] });
    },
    meta: {
      snackbarSuccessMessage: 'Auto-generated review has been deleted successfully.',
      snackbarErrorMessage: 'There was an issue deleting the Auto-generated review.  Please contact support.'
    }
  });
  return { removeAutoGenReviews, isLoadingRemoveAutoGenReviews };
}
